import React from 'react';
import Logo from '../../Logo';

const Brand: React.FC = () => {
  return (
    <a href="#" className="app-brand-link gap-2 align-items-center mb-2" onClick={(e) => e.preventDefault()}>
      <Logo sidebarExpanded={true} />
    </a>
  );
};

export default Brand;

